/* eslint-disable */

import { faDownload, faFileExcel, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, DropdownItem, DropdownToggle } from '@patternfly/react-core';
import { useState } from 'react';
import axiosConfig from '../../api/axiosConfig';
import { Documents } from '../../api/documents/Documents';

type DownloadActionsProps = {
	actionUrl: string;
	file_path: string;
	documentId: number;
	getAllDocuments: () => void;
};

export const DocumentDownloadActions = ({
	actionUrl,
	file_path,
	documentId,
	getAllDocuments,
}: DownloadActionsProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const onToggle = () => setIsOpen((prev) => !prev);
	const onSelect = () => setIsOpen(false);

	const handleCsvDownload = () => {
		const link = document.createElement('a');
		link.href = actionUrl;
		link.download = '';
		link.target = '_blank';
		link.click();
	};

	const handleXlsxDownload = async () => {
		try {
			const response = await axiosConfig.instance.post(
				'app/s3/download',
				{
					path: file_path,
					type: 'xlsx',
				},
				{ responseType: 'blob' } // Axios automatically gives you the blob data
			);

			// Extract filename from headers (Axios gives you a plain object for headers)
			const contentDisposition = response.headers['content-disposition'];
			let filename = `${file_path.replace('.csv', '')}.xlsx`;

			if (contentDisposition && contentDisposition.includes('filename=')) {
				const match = contentDisposition.match(/filename="?([^"]+)"?/);
				if (match?.[1]) filename = match[1];
			}

			// Create blob from Axios response
			const blob = new Blob([response.data], {
				type:
					response.headers['content-type'] ||
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			});

			// Create temporary download link
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = filename;
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();

			// Cleanup
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Error downloading XLSX file:', error);
		}
	};

	const handleDocumentClear = () => {
		Documents.Clear(documentId).then((response) => {
			getAllDocuments();
		});
	};

	return (
		<Dropdown
			isOpen={isOpen}
			onSelect={onSelect}
			menuAppendTo={() => document.body}
			toggle={
				<DropdownToggle onToggle={onToggle}>
					<FontAwesomeIcon
						icon={faDownload}
						style={{ cursor: 'pointer' }}
					/>
				</DropdownToggle>
			}
			dropdownItems={[
				<>
					<DropdownItem
						key="csv"
						onClick={() => {
							handleCsvDownload();
						}}
						icon={<FontAwesomeIcon icon={faDownload} />}
					>
						Download CSV
					</DropdownItem>
					<DropdownItem
						key="xlsx"
						onClick={() => {
							void handleXlsxDownload();
						}}
						icon={<FontAwesomeIcon icon={faFileExcel} />}
					>
						Download XLSX
					</DropdownItem>
					<DropdownItem
						key="clear"
						onClick={() => {
							handleDocumentClear();
						}}
						icon={<FontAwesomeIcon icon={faTrash} />}
					>
						Clear Document
					</DropdownItem>
				</>,
			]}
		></Dropdown>
	);
};
